export const schoolLevel = [
	// { name: '未知', val: 0 },
	{ name: '省级', val: 1 },
	{ name: '市级', val: 2 },
	{ name: '区级', val: 3 }
]
export const schoolType = [
	{ name: '城镇', val: 2 },
	{ name: '乡村', val: 1 },
	{ name: '未知', val: 0 }
]
export const scores = [
	{ name: '未知', val: 0 },
	{ name: '分数', val: 1 },
	{ name: '等级', val: 2 }
]

export const applicationRules = {
  realname: [{ required: true, message: '请输入名字', trigger: ['blur', 'change'] }],
	region_code: [{ required: true, message: '请选择辖区', trigger: ['blur', 'change'] }],
	admin_level: [{ required: true, message: '请选择层级', trigger: ['blur', 'change'] }]
}
